import React, { useMemo } from 'react';
//components
import Text from "components/Text";
import { Visibility } from 'components/Visibility';
import Input from "pages/Quotes/components/generics/Input/Input";
import { AutoMapping } from 'pages/Quotes/components/Tags/AutoMapping';
import MedicineTypeTag from 'pages/Quotes/components/Tags/MedicineTypeTag';
import ProductSegmentTag from 'pages/Quotes/components/Tags/ProductSegmentTag';
import { RefrigeratedTag } from 'pages/Quotes/components/Tags/RefrigeratedTag';
//interface
import { ProductsSuggestionProps } from 'pages/Quotes/MapProduct/interface';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
import { useConversionFactorContext } from 'contexts/ConversionFactor';
//utils
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { onlyNumbersNonNull } from 'pages/Quotes/utils/patterns';
//styles
import * as S from "../../../../styles";

interface MapProductLineProps {
  isEditing: boolean;
  notBlockBCG: boolean;
  sequenceNumber: string;
  quantityRule: number | string;
  suggested: ProductsSuggestionProps;
  textTooltip: (text: string) => string;
}

export const MapProductLine: React.FC<MapProductLineProps> = (props) => {
  const { suggested, quantityRule, sequenceNumber, isEditing, textTooltip, notBlockBCG } = props;
  const { conversionFactor, setConversionFactor, updateConversionFactorItem } = useConversionFactorContext();
  const { setQuoteItem, quoteItem, useMoney } = useDetailsQuoteContext();

  const handleConversionFactor = (value: string) => {
    const oldQuoteItem = { ...quoteItem };

    const item = oldQuoteItem.data?.find(item => item.sequenceNumber === sequenceNumber);

    if (!IsNullOrEmpty(item)) {
      const index = item?.productsSuggestion?.findIndex(item => item.supplierProductcode === suggested.supplierProductcode);

      if (index !== -1)
        item!.productsSuggestion![index!].conversionFactor = Number(value);
    }

    setQuoteItem({
      data: oldQuoteItem.data,
      pageSize: oldQuoteItem?.pageSize ?? 0,
      error: oldQuoteItem.error,
      total: oldQuoteItem?.total ?? 0,
      totalPages: oldQuoteItem?.totalPages ?? 0
    });

    setConversionFactor(Number(value));
  };

  return (
    <>
      <S.Cell className="id" isAutomatic={suggested && suggested?.isCreatedAutomatically}>
        <p>{suggested?.supplierProductcode}</p>
      </S.Cell>
      <S.Cell className="description">
        <div className="descriptionText">
          <Visibility visible={suggested && suggested?.isCreatedAutomatically}>
            <AutoMapping />
          </Visibility>
          <Visibility visible={!!suggested?.description || !!suggested?.supplierProductDescription}>
            <Text showTip toolTipPlace="left" showTipContent={textTooltip(suggested?.description || suggested?.supplierProductDescription)}>
              {suggested?.description || suggested?.supplierProductDescription}
            </Text>
          </Visibility>
          <Visibility visible={!!suggested?.substance}>
            <Text showTip toolTipPlace="left" showTipContent={textTooltip(suggested?.substance)} className="activeIngredient">
              {suggested?.substance}
            </Text>
          </Visibility>
        </div>
      </S.Cell>

      <S.Cell className="tagsMedicineTipe">
        <Visibility visible={!!suggested}>
          <div className="tagsComponents">
            {suggested?.productSegmentDescription &&
              <ProductSegmentTag
                className="productSegmentTagDiv"
                tagText={suggested?.productSegmentDescription.toUpperCase()}
              />
            }
            {suggested?.medicineTypeDescription &&
              <MedicineTypeTag
                className="medicineTypeTagDiv"
                tagText={suggested?.medicineTypeDescription}
              />
            }
          </div>
          <RefrigeratedTag refrigerated={suggested?.refrigeration === "SIM"} />
        </Visibility>
      </S.Cell>

      <S.Cell className="producer">
        <Visibility visible={!!suggested?.producer || !!suggested?.manufacturer}>
          <Text showTip toolTipPlace="left" showTipContent={textTooltip(suggested?.producer || suggested?.manufacturer)}>{suggested?.producer || suggested?.manufacturer}</Text>
        </Visibility>
      </S.Cell>
      <S.Cell className="quantity">
        <p>{quantityRule}</p>
      </S.Cell>
      <S.Cell className="unit">
        <Visibility visible={!!suggested?.unit || !!suggested?.purchaseUnit}>
          <Text showTip toolTipPlace="left" showTipContent={textTooltip(suggested?.unit || suggested?.purchaseUnit)}>{suggested?.unit || suggested?.purchaseUnit}</Text>
        </Visibility>
      </S.Cell>
      <S.Cell className="conversionFactor">
        <Visibility visible={!!suggested && notBlockBCG}>
          <span className="subtitle">Conversão</span>
          <div className="value" style={{ alignItems: "baseline" }}>
            {!isEditing ? (
              <div className="value">{suggested?.conversionFactor}</div> 
            ) : (
              <Input
                width="60px"
                type="number"
                isValid={true}
                readOnly={!useMoney}
                setIsValid={() => { }}
                alt='inputConversionFactor'
                pattern={onlyNumbersNonNull}
                onChange={(e: string) => {
                  handleConversionFactor(e);
                }}
                value={String(conversionFactor)}
                onBlur={conversionFactor && conversionFactor > 0 && updateConversionFactorItem}
              />
            )}
          </div>
        </Visibility>
      </S.Cell>
    </>
  );
};